export default "__VITE_ASSET__CqIrgRhl__"